import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useGetMaritalStatusTypesQuery } from '../../../../services/RegistrationService';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { updateRegistration } from '../../../../services/RegistrationService/registrationSlice/';

const MaritalStatusEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const demographics = useAppSelector(state => state.registration.currentRegistration?.demographics) || {};
  const value = demographics.maritalStatus || '';
  const { data: maritalStatusTypes = [], isLoading } = useGetMaritalStatusTypesQuery();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateRegistration({
      demographics: {
        ...demographics,
        maritalStatus: e.target.value,
      },
    }));
  };

  return (
    <TextField
      select
      value={value}
      onChange={handleChange}
      size="small"
      label="Marital Status"
      disabled={isLoading}
      sx={{ width: 205 }}
    >
      <MenuItem value="">
        Select Marital Status
      </MenuItem>
      {maritalStatusTypes.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default MaritalStatusEdit;
